import styled from '@emotion/styled'
import React from 'react'
import { Footer } from '../../Components/Footer'
import { Header } from './Sections/S1_Header'
import { About } from './Sections/S2_About'
import { Features } from './Sections/S3_Features'
import { Ticker } from './Sections/S5_Ticker'
import { Tokenomics } from './Sections/S6_Tokenomics'
import { FAQs } from './Sections/S7_FAQs'
import bk1 from '../../images/main-background/bk-radial-1.png'
import bk2 from '../../images/main-background/bk-radial-2.png'
import bk3 from '../../images/main-background/bk-radial-3.png'
import bk4 from '../../images/main-background/bk-radial-4.png'
import bk5 from '../../images/main-background/bk-radial-5.png'
import bk6 from '../../images/main-background/bk-radial-6.png'
import bk7 from '../../images/main-background/bk-radial-7.png'
import bk8 from '../../images/main-background/bk-radial-8.png'
import bk9 from '../../images/main-background/bk-radial-9.png'
import bk10 from '../../images/main-background/bk-radial-10.png'
// import bk from '../../images/main-background/bk-radial-.png'

const Page = styled.div`
  /* background: linear-gradient(355deg, rgba(10, 47, 66, 0.5), rgba(3, 29, 47, 0.5)); */
  background: linear-gradient(355deg, rgba(10, 47, 66, 0.3), rgba(3, 29, 47, 0.3)),
              url(${bk1}),
              url(${bk2}),
              url(${bk3}),
              url(${bk4}),
              url(${bk6}),
              url(${bk8}),
              url(${bk10});
  background-repeat: no-repeat;
  background-position:0 0, 100% 0%,0% 14%,100% 24%,0% 65%,100% 70%,100% 110%,0% 118%;
  background-size: 100%, 130%, 130%, 130%, 130%, 130%, 130%, 130%;
  backdrop-filter: blur(5px);

  @media (min-width: 600px) { background-size: 100%, 85%, 85%, 85%, 85%, 85%, 85%, 85%; }
  @media (min-width: 900px) { background-size: 100%, 60%, 60%, 60%, 60%, 60%, 60%, 60%; }
  @media (min-width: 1200px) { background-size: 100%, 45%, 45%, 45%, 45%, 45%, 45%, 45%; }
  @media (min-width: 1536px) { background-size: 100%, 30%, 30%, 30%, 30%, 30%, 30%, 30%; }    
`

export const Home = () => {
  return (
    <Page style={{overflowX:"hidden"}}>
        <Header />
        <About />
        <Features />
        <Ticker />
        <Tokenomics />
        <FAQs />
        <Footer />
    </Page>
  )
}
